<template>
  <div class="content">
    <div class="head" @click="goOut">
      <i class="el-icon-arrow-left go_icon" />
      <div>流程管理</div>
    </div>
    <div class="content_list">
      <!-- 顶部搜索 -->
      <div class="nav_box">
        <div class="nav_left">
          <div class="search_input">
            <el-input
              placeholder="请输入内容"
              v-model="queryInfo.query"
              clearable
              @change="searchI"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" @click="searchI" />
            </el-input>
          </div>
        </div>
        <div class="nav_left">
          <el-button @click="openDialog">
            <i
              class="iconfont icon-jiahao1 custom_icon"
              style="font-size: 13px"
            />
            创建流程分类
          </el-button>
          <el-button type="primary" @click="openDialog1">
            <i
              class="iconfont icon-jiahao1 custom_icon"
              style="color: #ffffff"
            />
            创建流程
          </el-button>
        </div>
      </div>
      <div v-if="search_list" class="data_list">
        <div v-if="list.length>0">
          <el-row
            class="content_row"
            v-for="(key, index1) in list"
            :key="index1"
            @click.native="openProcess(key)"
          >
            <el-tooltip
              effect="dark"
              :content="key.flowName"
              placement="bottom"
              popper-class="texttooltip"
              :open-delay="500"
            >
              <el-col
                :span="4"
                style="overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;"
              >{{key.flowName}}</el-col>
            </el-tooltip>
            <el-col :span="2">
              <div v-if="key.status == 0" style="color: #2db039">正常</div>
              <el-tooltip effect="dark" popper-class="texttooltip" content="停用后无法使用该流程创建新任务" placement="top" v-else-if="key.status == 1">
                <span style="color: #dd483f">停用</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4">
              <div class="info_personnel1" v-if="key.createUser && key.createUser.name">
                <img class="info_personnel_surname" v-if="key.createUser.avatar!=''" :src="key.createUser.avatar">
                <div class="info_personnel_surname" v-else>{{(key.createUser.name).substring(0,1)}}</div>
                <div v-if="channel === 'wechat'"> <ww-open-data type="userName" :openid="key.createUser.name" /></div>
                <div v-else>{{key.createUser.name}}</div>
              </div>
              <div v-else style="width:10px;height:24px" />
            </el-col>
            <el-col :span="2">
              <div v-if="key.activatFlag == 1" style="color: #2db039">已设置</div>
              <el-tooltip effect="dark" popper-class="texttooltip" content="部分节点未设置执行人，无法使用该流程创建新任务" placement="top" v-else-if="key.activatFlag == 0">
                <span style="color: #dd483f">未设置</span>
              </el-tooltip>
            </el-col>
            <el-col :span="7">{{key.updateDate}}</el-col>
            <el-col :span="5">
              <div class="content_btn">
                <el-tooltip
                  effect="dark"
                  content="配置"
                  placement="top"
                  popper-class="texttooltip"
                >
                  <i class="iconfont icon-shezhi icon_btn" @click.stop="openProcess(key)" style="color:#909090" />
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="编辑"
                  placement="top"
                  popper-class="texttooltip"
                >
                  <i class="iconfont icon-edit icon_btn" @click.stop="openDialog2(key, index1)" />
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="复制"
                  placement="top"
                  popper-class="texttooltip"
                >
                  <i class="iconfont icon-fuzhi icon_btn" @click.stop="openDialogCopy(key, key, index1)" />
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="权限设置"
                  placement="top"
                  popper-class="texttooltip"
                >
                  <i class="iconfont icon-quanxianshezhi icon_btn" @click.stop="openDialog3(key, index1)" />
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="恢复"
                  placement="top"
                  popper-class="texttooltip"
                >
                  <i
                    style="font-size:15px"
                    class="iconfont icon-ico_huifutuopushuju icon_btn"
                    v-show="key.status == 1"
                    @click.stop="setUpFlowStatusDialog(key, index1)"
                  />
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="停用"
                  placement="top"
                  popper-class="texttooltip"
                >
                  <i
                    class="iconfont icon-zanting2 icon_btn"
                    v-show="key.status == 0"
                    @click.stop="setUpFlowStatusDialog(key, index1)"
                  />
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="删除"
                  placement="top"
                  popper-class="texttooltip"
                >
                  <i class="iconfont icon-shanchu1 icon_btn" @click.stop="delFlowDialog(key, index1, '')" style="font-size:15px;" />
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <noDate />
        </div>
      </div>
      <!-- @scroll="scrollEvent"  v-infinite-scroll="load"-->
      <div v-else @scroll="load" infinite-scroll-distance="15" style="flex:1;overflow-y:auto;width: calc(100% - -15px);height: calc(100% - 92px);">
        <el-collapse
          v-model="queryInfo.activeName"
          @change="handleChange"
        >
          <el-collapse-item
            :name="item.id"
            v-for="(item, index) in processList"
            :key="index"
            :collapse-transition="false"
          >
            <span class="collapse-title" slot="title">
              <span class="collapse-title-name">
                {{item.typeName}}
              </span>
              <span>({{item.flowCount}})</span>
              <span v-if="queryInfo.activeName == item.id && index > 0">
                <i
                  class="iconfont icon-edit"
                  style="margin-left: 23px; margin-right: 17px"
                  @click.stop="openDialog4(item, index)"
                />
                <i class="iconfont icon-shanchu1" @click.stop="delFlowTypeDialog(item, index)" />
              </span>
            </span>
            <w-loading text="加载中.." :mask="true" :click="true" ref="loading" />
            <div class="content_box" v-if="item.List" :style="'height:' + (item.List.length) * 40 + 'px'">
              <el-row
                class="content_row"
                v-for="(key, index1) in item.List"
                :key="index1"
                @click.native="openProcess(key)"
              >
                <el-tooltip
                  effect="dark"
                  :content="key.flowName"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <el-col
                    :span="4"
                    style="overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;"
                  >{{key.flowName}}</el-col>
                </el-tooltip>
                <el-col :span="2">
                  <div v-if="key.status == 0" style="color: #2db039">正常</div>
                  <el-tooltip effect="dark" popper-class="texttooltip" content="停用后无法使用该流程创建新任务" placement="top" v-else-if="key.status == 1">
                    <span style="color: #dd483f">停用</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="4">
                  <div class="info_personnel1" v-if="key.createUser && key.createUser.name">
                    <img class="info_personnel_surname" v-if="key.createUser.avatar!=''" :src="key.createUser.avatar">
                    <div class="info_personnel_surname" v-else>{{(key.createUser.name).substring(0,1)}}</div>
                    <div v-if="channel === 'wechat'"> <ww-open-data type="userName" :openid="key.createUser.name" /></div>
                    <div v-else>{{key.createUser.name}}</div>
                  </div>
                  <div v-else style="width:10px;height:24px" />
                </el-col>
                <el-col :span="2">
                  <div v-if="key.activatFlag == 1" style="color: #2db039">已设置</div>
                  <el-tooltip effect="dark" popper-class="texttooltip" content="部分节点未设置执行人，无法使用该流程创建新任务" placement="top" v-else-if="key.activatFlag == 0">
                    <span style="color: #dd483f">未设置</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="7">{{key.updateDate}}</el-col>
                <el-col :span="5">
                  <div class="content_btn">
                    <el-tooltip
                      effect="dark"
                      content="配置"
                      placement="top"
                      popper-class="texttooltip"
                    >
                      <i class="iconfont icon-shezhi icon_btn" @click.stop="openProcess(key)" style="color:#909090" />
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="编辑"
                      placement="top"
                      popper-class="texttooltip"
                    >
                      <i class="iconfont icon-edit icon_btn" @click.stop="openDialog2(key, index1)" />
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="复制"
                      placement="top"
                      popper-class="texttooltip"
                    >
                      <i class="iconfont icon-fuzhi icon_btn" @click.stop="openDialogCopy(item, key, index1)" />
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="权限设置"
                      placement="top"
                      popper-class="texttooltip"
                    >
                      <i class="iconfont icon-quanxianshezhi icon_btn" @click.stop="openDialog3(key, index1)" />
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="恢复"
                      placement="top"
                      popper-class="texttooltip"
                    >
                      <i
                        style="font-size:15px"
                        class="iconfont icon-ico_huifutuopushuju icon_btn"
                        v-show="key.status == 1"
                        @click.stop="setUpFlowStatusDialog(key, index1)"
                      />
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="停用"
                      placement="top"
                      popper-class="texttooltip"
                    >
                      <i
                        class="iconfont icon-zanting2 icon_btn"
                        v-show="key.status == 0"
                        @click.stop="setUpFlowStatusDialog(key, index1)"
                      />
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="删除"
                      placement="top"
                      popper-class="texttooltip"
                    >
                      <i class="iconfont icon-shanchu1 icon_btn" @click.stop="delFlowDialog(key, index1, index)" style="font-size:15px;" />
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <!-- 创建流程分类弹框 -->
    <Dialogs :dialogs="dialog" @dialogVisible="beforeClose">
      <template #desc>
        <div class="cover_boxs">
          <div class="info_subject">
            <el-input
              type="textarea"
              placeholder="请输入流程分类名称"
              v-model="dialog.typeName"
              :autosize="{ minRows: 1, maxRows: 5}"
              maxlength="200"
              show-word-limit
            />
          </div>
        </div>
      </template>
    </Dialogs>
    <!--创建流程弹框 -->
    <Dialogs :dialogs="dialog1" @dialogVisible="beforeClose">
      <template #desc>
        <div class="cover_boxs">
          <div class="info_subject">
            <el-input
              type="textarea"
              placeholder="请输入流程名称，200字以内"
              v-model="dialog1.flowName"
              :autosize="{ minRows: 1, maxRows: 5}"
              maxlength="200"
              show-word-limit
            />
          </div>
          <div class="create_box">
            <div class="create_key">
              <i
                class="iconfont icon-type create_icon"
              />
              <div>流程分类</div>
            </div>
            <div class="create_value">
              <el-select v-model="dialog1.typeId" placeholder="请选择" filterable>
                <el-option
                  v-for="item in processLists"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                />
              </el-select>
            </div>
          </div>
        </div>
      </template>
    </Dialogs>
    <!-- 编辑流程弹框 -->
    <Dialogs :dialogs="dialog2" @dialogVisible="beforeClose">
      <template #desc>
        <div class="cover_boxs">
          <div class="info_subject">
            <el-input
              type="textarea"
              placeholder="请输入流程分类名称"
              v-model="dialog2.flowName"
              :autosize="{ minRows: 1, maxRows: 5}"
              maxlength="200"
              show-word-limit
            />
          </div>
        </div>
        <div class="create_box">
          <div class="create_key">
            <i
              class="iconfont icon-type create_icon"
            />
            <div>流程分类</div>
          </div>
          <div class="create_value">
            <el-select v-model="dialog2.typeIds" placeholder="请选择" filterable @change="pcmFormTypeChange">
              <el-option
                v-for="item in processLists"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
      </template>
    </Dialogs>
    <!-- 设置可见权限弹框 -->
    <Dialogs :dialogs="dialog3" @dialogVisible="beforeClose">
      <template #desc>
        <div class="permissions_box" style="height: 60px;">
          <div>
            <div class="permissions_label">修改权限
              <el-tooltip effect="dark" popper-class="texttooltip" placement="right">
                <div slot="content">发起流程任务后，是否支持修改任务信息</div>
                <i class="iconfont icon-shuoming progress_icon" />
              </el-tooltip>
            </div>
            <div class="permissions_value">
              <el-radio-group v-model="permissions.taskEditFlag">
                <el-radio label="0">支持修改</el-radio>
                <el-radio label="1">不支持修改</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="permissions_box">
          <div>
            <div class="permissions_label">可见范围</div>
            <div class="permissions_value">
              <el-radio-group v-model="permissions.authType">
                <el-radio label="0">全部项目成员可见</el-radio>
                <el-radio label="1">部分项目成员可见</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div v-show="permissions.authType == 1">
            <div class="permissions_label">可见成员</div>
            <div class="users_personnel">
              <div class="user_personnel" v-for="(item,index) in permissions.authUserList" :key="index">
                <div class="info_personnel" @click="contactCh(permissions.authUserList)">
                  <img v-if="item.avatar!=''&& item.avatar !== null" class="info_personnel_surname" :src="item.avatar">
                  <div v-else class="info_personnel_surname">{{(item.name).substring(0,1)}}</div>
                  <div v-if="channel === 'wechat'"> <ww-open-data type="userName" :openid="item.name" /></div>
                  <div v-else>{{item.name}}</div>
                </div>
                <i class="iconfont icon-shanchu del_icon" @click="delUsers(permissions.authUserList, index)" />
              </div>
              <i class="iconfont icon-jiahao2fill add_icon" @click="contactCh(permissions.authUserList)" :style="permissions.authUserList.length>0?'margin-left:34px':''" />
            </div>
          </div>
        </div>
      </template>
    </Dialogs>
    <!-- 编辑流程分类弹框 -->
    <Dialogs :dialogs="dialog4" @dialogVisible="beforeClose">
      <template #desc>
        <div class="cover_boxs">
          <div class="info_subject">
            <el-input
              type="textarea"
              placeholder="请输入流程分类名称"
              v-model="dialog4.typeName"
              :autosize="{ minRows: 1, maxRows: 5}"
              maxlength="200"
              show-word-limit
            />
          </div>
        </div>
      </template>
    </Dialogs>
    <!-- 编辑流程弹框 -->
    <Dialogs :dialogs="dialogCopy" @dialogVisible="beforeClose">
      <template #desc>
        <div class="cover_boxs">
          <div class="info_subject">
            <el-input
              type="textarea"
              placeholder="请输入流程分类名称"
              v-model="dialogCopy.flowName"
              :autosize="{ minRows: 1, maxRows: 5}"
              maxlength="200"
              show-word-limit
            />
          </div>
        </div>
        <div class="create_box">
          <div class="create_key">
            <i
              class="iconfont icon-type create_icon"
            />
            <div>流程分类</div>
          </div>
          <div class="create_value">
            <el-select v-model="dialogCopy.typeIds" placeholder="请选择" filterable @change="pcmFormTypeChange">
              <el-option
                v-for="item in processLists"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
      </template>
    </Dialogs>
    <selectingpeo ref="selectingPeo" @chooseUserFlag="taskFollow" />
  </div>
</template>

<script>
import selectingpeo from '../../components/common/selectingPeo/index.vue'
import Dialogs from '../../components/common/dialog.vue'
import noDate from '../../components/common/noDate.vue'
import { findGropList, notFlowTypeCount, saveFlowType, delFlowType, findPageList, saveFlow, setUpFlowStatus, delFlow, setUpFlowAuth, copyFlow } from '../../utils/api/process'
import { findUserIds } from '../../utils/api/user'
import choose from 'dingtalk-jsapi/api/biz/contact/choose' // PC 通讯录选人
import { feishuContactChoose } from '../../utils/fsConfig'
import Vue from 'vue'
import { wxConfig } from '../../utils/wxConfig'
export default {
  components: { Dialogs, noDate, selectingpeo },
  data() {
    return {
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      userId: JSON.parse(sessionStorage.getItem('loginUserData')).userId,
      tryOutType: JSON.parse(sessionStorage.getItem('loginUserData')).tryOutType,
      chooseUserFlag: JSON.parse(sessionStorage.getItem('loginUserData')).chooseUserFlag,
      queryInfo: {
        query: '',
        activeName: []
      },
      gropList_index: 0,
      processList: [
        {
          id: '1',
          typeName: '未分类',
          flowCount: 0,
          list: []
        }
      ],
      list_number: 1, // loading第一次
      processLists: [],
      page: 1,
      pageSize: 20,
      pageNum: 1,
      dateList: [],
      dateList_index: 0,
      search_list: false,
      list: [],
      // 创建流程分类弹框
      dialog: {
        addDounced: false, // 显示新增
        title: '创建流程分类',
        width: '600px',
        slotName: 'desc',
        typeName: '',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '创建', type: 'primary', fun: this.submitDialog }
        ]
      },
      // 创建流程弹框
      dialog1: {
        addDounced: false, // 显示新增
        title: '创建流程',
        width: '600px',
        slotName: 'desc',
        flowName: '',
        typeId: '',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '创建', type: 'primary', fun: this.submitDialog1 }
        ]
      },
      // 创建流程弹框
      dialog2: {
        addDounced: false, // 显示新增
        title: '编辑流程 ',
        width: '600px',
        slotName: 'desc',
        flowName: '',
        typeId: '',
        typeIds: '',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '保存', type: 'primary', fun: this.submitDialog2 }
        ]
      },
      // 创建流程弹框
      dialogCopy: {
        addDounced: false, // 显示新增
        title: '复制流程 ',
        width: '600px',
        slotName: 'desc',
        flowName: '',
        typeId: '',
        typeIds: '',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '确定', type: 'primary', fun: this.submitDialogcopy }
        ]
      },
      // 设置可见权限弹框
      dialog3: {
        addDounced: false,
        title: '设置可见权限',
        width: '600px',
        slotName: 'desc',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '确定', type: 'primary', fun: this.submitDialog3 }
        ]
      },
      // 权限设置
      permissions: {
        id: '',
        authType: '0',
        taskEditFlag: '0',
        userIds: [],
        authUserList: []
      },
      // 编辑流程分类弹框
      dialog4: {
        addDounced: false, // 显示新增
        title: '编辑流程分类名称',
        width: '600px',
        slotName: 'desc',
        id: '',
        typeName: '',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '保存', type: 'primary', fun: this.submitDialog4 }
        ]
      },
      FormTypeId: '',
      FormType: {}
    }
  },
  mounted() {
    this.page = 1
    if (this.channel === 'wechat') {
      wxConfig()
      setTimeout(() => {
        this.getGropList()
      }, 500)
    } else {
      this.getGropList()
    }
  },
  methods: {
    // 滚定监听
    scrollEvent(e) {
      if (Math.ceil(e.currentTarget.scrollTop + e.currentTarget.clientHeight) >= e.currentTarget.scrollHeight) { // 容差：20px
        if (this.pageNum > this.page) {
          this.page += 1
          this.getGropList()
        }
      }
    },
    load(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target
      // 判断是否滚动到底部
      const isBottom = scrollTop + clientHeight + 15 >= scrollHeight
      if (isBottom) {
        // 滚动条到达底部时的逻辑处理
        console.log('滚动条到达底部')
        if (this.pageNum > this.page) {
          this.page += 1
          this.getList1()
        }
      }
    },
    getList1() {
      var page = this.page
      var pageSize = this.pageSize
      findGropList(page, pageSize).then((data) => {
        if (data.code === 10000) {
          data.result.list.forEach(element => {
            element = Object.assign(element, {
              List: []
            })
          })
          this.processList = [...this.processList, ...data.result.list]
          this.processLists = [...this.processLists, ...data.result.list]
          this.pageNum = data.result.pages
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
      notFlowTypeCount().then((data) => {
        if (data.code === 10000) {
          this.processList[0].flowCount = data.result
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 钉钉通讯录选人组件
    contactChoose(userids) {
      var that = this
      choose({
        multiple: true, // 是否多选：true多选 false单选； 默认true
        users: userids, // 默认选中的用户列表，员工userid；成功回调中应包含该信息
        corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId, // 企业id
        max: 100, // 人数限制，当multiple为true才生效，可选范围1-1500
        // emplId 员工ID
        onSuccess: function(res) {
          if (res.length > 0) {
            var date = {
              users: res
            }
            findUserIds(date).then((res1) => {
              if (res1.code === 10000 && res1.result.isAll) {
                that.permissions.authUserList = res1.result.userList
              } else {
                this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
              }
            }).catch((error) => {
              console.log(error)
              //  this.$message.error('网络错误，请稍候！')
            })
          }
        },
        onFail: function(err) {
          console.log(err)
        }
      }).then((res) => {
        console.log('then______err', res)
        // alert('$ANTDD error: ' + JSON.stringify(err))
      }).catch((err) => {
        console.log('catch______err', err)
        // alert('$ANTDD error: ' + JSON.stringify(err))
      })
    },
    // 企微通讯录选人组件
    wechatLogin(userids) {
      var that = this
      if (this.tryOutType === '1') {
        Vue.prototype.$wx.invoke('selectPrivilegedContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': 'multi', // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectPrivilegedContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList || [] // 已选的成员列表
            const selectedTicket = res.result.selectedTicket || '' // 已选的成员Ticket列表
            if (selectedUserList.length > 0 || selectedTicket.length > 0) {
              var date = {
                type: 'user',
                users: selectedUserList,
                ticket: selectedTicket
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.permissions.authUserList = res1.result.userList
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      } else {
        Vue.prototype.$wx.invoke('selectEnterpriseContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': 'multi', // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectEnterpriseContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList // 已选的成员列表
            if (selectedUserList.length > 0) {
              var date = {
                users: selectedUserList
              }
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.permissions.authUserList = res1.result.userList
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      }
    },
    // 飞书选人
    fsContactChoose(userids) {
      var multiple = true
      feishuContactChoose(userids, multiple).then((res) => {
        if (res.length > 0) {
          const result = res.map(item => ({ id: item.openId }))
          var date = {
            users: result
          }
          findUserIds(date).then((res1) => {
            if (res1.code === 10000 && res1.result.isAll) {
              this.permissions.authUserList = res1.result.userList
            } else {
              this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      })
    },
    // 选择人员
    taskFollow(userList) {
      this.permissions.authUserList = userList
    },
    // 添加人员
    contactCh(principalUsers) {
      if (!principalUsers) {
        principalUsers = []
      }
      var userids = []
      principalUsers.map((item) => {
        userids.push(item.userid)
      })
      var multiple = true
      if (this.chooseUserFlag === '1') {
        this.$refs.selectingPeo.openDialog(principalUsers, '', multiple)
      } else if (this.channel === 'ding') {
        this.contactChoose(userids)
      } else if (this.channel === 'wechat') {
        this.wechatLogin(userids)
      } else {
        this.fsContactChoose(userids)
      }
    },
    // 删除人员
    delUsers(principalUsers, index) {
      principalUsers.splice(index, 1)
    },
    // 搜索
    searchI() {
      this.queryInfo.activeName = ''
      this.list = []
      if (this.queryInfo.query !== '') {
        this.search_list = true
        this.getList()
      } else {
        this.search_list = false
        this.processList = [
          {
            id: '1',
            typeName: '未分类',
            formCount: 0,
            list: []
          }
        ]
        this.page = 1
        this.processLists = []
        this.getGropList()
      }
    },
    // 流程分类列表
    getGropList() {
      var page = this.page
      var pageSize = this.pageSize
      findGropList(page, pageSize).then((data) => {
        if (data.code === 10000) {
          data.result.list.forEach(element => {
            element = Object.assign(element, {
              List: []
            })
          })
          this.processList = [...this.processList, ...data.result.list]
          this.processLists = [...this.processLists, ...data.result.list]
          this.pageNum = data.result.pages
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
      notFlowTypeCount().then((data) => {
        if (data.code === 10000) {
          this.processList[0].flowCount = data.result
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 点击折叠面板
    handleChange(activeNames) {
      // this.dateList = []
      const id = this.queryInfo?.activeName.pop()
      // this.queryInfo.activeName = []
      this.processList.map((item, index) => {
        if (item.id === id) {
          // console.log(item, index)
          this.gropList_index = index
          this.getList(item, id, index)
        }
      })
    },
    // 流程列表
    getList(item, activeNames, index) {
      this.list = []
      var that = this
      var date = {}
      if (item && item.id === '1') {
        date = {
          notTypeId: '1'
          // typeId: '1'
        }
      } else if (item && item.id !== '1') {
        date = {
          typeId: item.id,
          flowName: this.queryInfo.query
        }
      } else {
        date = {
          flowName: this.queryInfo.query
        }
      }
      findPageList(date).then((data) => {
        if (data.code === 10000) {
          if (item) {
            item.List = data.result
            if (data.result && data.result.length > 0) {
              this.list_number += 1
            }
            this.$nextTick(() => {
              that.queryInfo.activeName = [activeNames]
              // this.queryInfo.activeName.push(activeNames)
            })
          } else {
            this.list = data.result
          }
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 打开任务流程图
    openProcess(key) {
      this.$router.push({
        path: '/More/ProcessDetail',
        query: {
          id: key.id,
          name: key.flowName
        }
      })
    },
    // 打开创建流程分类
    openDialog() {
      this.dialog.addDounced = true
    },
    // 关闭前的回调(弹框)
    beforeClose(val) {
      this.dialog.addDounced = val.addDounced
      this.dialog1.addDounced = val.addDounced
      this.dialog2.addDounced = val.addDounced
      this.dialog3.addDounced = val.addDounced
      this.dialog4.addDounced = val.addDounced
      this.dialogCopy.addDounced = val.addDounced
    },
    // 弹框取消
    cancelDialog() {
      this.dialog.addDounced = false
      this.dialog1.addDounced = false
      this.dialog2.addDounced = false
      this.dialog3.addDounced = false
      this.dialog4.addDounced = false
      this.dialogCopy.addDounced = false
    },
    // 弹框创建流程分类
    submitDialog() {
      if (this.dialog.flowName === '') {
        this.$message.warning('流程分类名称不能为空！')
        return
      }
      var date = {
        typeName: this.dialog.typeName
      }
      saveFlowType(date).then((data) => {
        if (data.code === 10000) {
          this.processList = [
            {
              id: '1',
              typeName: '未分类',
              flowCount: 0,
              list: []
            }
          ]
          this.page = 1
          this.processLists = []
          this.getGropList()
          // this.$message.success('流程分组创建成功！')
          this.dialog.addDounced = false
          this.dialog.typeName = ''
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 打开弹框
    openDialog1() {
      this.dialog1.addDounced = true
      this.dialog1.flowName = ''
      this.dialog1.typeId = ''
    },
    // 弹框创建流程
    submitDialog1() {
      if (this.dialog1.flowName === '') {
        this.$message.warning('流程名称不能为空！')
        return
      }
      // else if (this.dialog1.typeId === '') {
      //   this.$message.warning('流程分类不能为空！')
      //   return
      // }
      var date = {}
      if (this.dialog1.typeId === '1') {
        date = {
          flowName: this.dialog1.flowName
        }
      } else {
        date = {
          typeId: this.dialog1.typeId,
          flowName: this.dialog1.flowName
        }
      }
      saveFlow(date).then((data) => {
        if (data.code === 10000) {
          this.dateList = []
          this.getList(this.processList[this.gropList_index], this.queryInfo.activeName)
          this.processList = [
            {
              id: '1',
              typeName: '未分类',
              flowCount: 0,
              list: []
            }
          ]
          this.page = 1
          this.processLists = []
          this.getGropList()
          // this.$message.success('流程创建成功！')
          this.dialog1.addDounced = false
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 打开编辑流程弹框
    openDialog2(item, index) {
      this.dateList_index = index
      this.dialog2.addDounced = true
      this.dialog2.id = item.id
      this.dialog2.flowName = item.flowName
      this.FormType = item
      this.FormTypeId = item.id
      if (item.pcmFlowType === null) {
        this.dialog2.typeIds = ''
        this.dialog2.typeName = ''
      } else {
        this.dialog2.typeIds = item.pcmFlowType.id
        this.dialog2.typeName = item.pcmFlowType.typeName
      }
    },
    // 打开复制流程弹窗
    openDialogCopy(itemD, item, index) {
      const nowDate = new Date()
      const date = {
        hours: nowDate.getHours(),
        minutes: nowDate.getMinutes()
      }
      const newminutes = date.minutes < 10 ? '0' + date.minutes : date.minutes
      this.newTime = date.hours + '' + newminutes
      this.dialogCopy.addDounced = true
      this.dialogCopy.id = item.id
      this.dialogCopy.flowName = item.flowName + '_' + this.newTime
      this.FormType = item
      this.FormTypeId = item.id
      if (item.pcmFlowType === null) {
        this.dialogCopy.typeIds = ''
        this.dialogCopy.typeName = ''
      } else {
        this.dialogCopy.typeIds = item.pcmFlowType.id
        this.dialogCopy.typeName = item.pcmFlowType.typeName
      }
    },
    // 流程复制确定
    submitDialogcopy() {
      var date = {
        id: this.dialogCopy.id,
        flowName: this.dialogCopy.flowName,
        typeId: this.dialogCopy.typeIds
      }
      copyFlow(date).then((data) => {
        if (data.code === 10000) {
          if (this.list.length === 0) {
            this.processList[this.gropList_index].List[this.dateList_index].flowName = this.dialogCopy.flowName
          } else {
            // this.list[this.dateList_index].flowName = this.dialogCopy.flowName
            this.list.unshift(data.result)
          }
          // this.$message.success('流程编辑成功！')
          this.dialogCopy.addDounced = false
          if (this.dialogCopy.id !== this.FormTypeId) {
            this.processList = [
              {
                id: '1',
                typeName: '未分类',
                formCount: 0,
                list: []
              }
            ]
            this.processLists = []
            this.page = 1
            this.getGropList()
            this.getList(this.FormType, this.dialogCopy.id)
          } else {
            this.handleChange(this.FormTypeId)
          }
          this.$forceUpdate()
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    pcmFormTypeChange(val) {
      this.FormTypeId = val
    },
    // 编辑流程弹框
    submitDialog2() {
      if (this.dialog2.flowName === '') {
        this.$message.warning('流程名称不能为空！')
        return
      }
      var date = {
        id: this.dialog2.id,
        typeId: this.dialog2.typeIds,
        // typeId: this.gropList_index,
        flowName: this.dialog2.flowName
      }
      saveFlow(date).then((data) => {
        if (data.code === 10000) {
          if (this.list.length === 0) {
            this.processList[this.gropList_index].List[this.dateList_index].flowName = this.dialog2.flowName
          } else {
            this.list[this.dateList_index].flowName = this.dialog2.flowName
          }
          // this.$message.success('流程编辑成功！')
          this.dialog2.addDounced = false
          if (this.dialog2.id !== this.FormTypeId) {
            this.processList = [
              {
                id: '1',
                typeName: '未分类',
                formCount: 0,
                list: []
              }
            ]
            this.processLists = []
            this.page = 1
            this.getGropList()
            this.getList(this.FormType, this.dialog2.id)
          }
          this.$forceUpdate()
        } else {
          this.handleChange(this.FormTypeId)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 打开弹框
    openDialog3(item, index) {
      this.dateList_index = index
      this.dialog3.addDounced = true
      this.permissions.id = item.id
      this.permissions.authType = item.authType
      if (item.taskEditFlag === null) {
        this.permissions.taskEditFlag = '0'
      } else {
        this.permissions.taskEditFlag = item.taskEditFlag
      }
      this.permissions.authUserList = item.authUserList || []
    },
    // 弹框权限设置
    submitDialog3() {
      var list = this.permissions.authUserList || []
      var userIds = []
      list.map((item) => {
        userIds.push(item.id)
      })
      var date = {
        id: this.permissions.id,
        authType: this.permissions.authType,
        taskEditFlag: this.permissions.taskEditFlag,
        userIds: userIds
      }
      setUpFlowAuth(date).then((data) => {
        if (data.code === 10000) {
          this.processList[this.gropList_index].List[this.dateList_index].authUserList = this.permissions.authUserList
          this.processList[this.gropList_index].List[this.dateList_index].authType = this.permissions.authType
          this.processList[this.gropList_index].List[this.dateList_index].taskEditFlag = this.permissions.taskEditFlag
          // this.$message.success('流程权限设置成功！')
          this.dialog3.addDounced = false
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 打开编辑流程分类
    openDialog4(item, index) {
      this.gropList_index = index
      this.dialog4.addDounced = true
      this.dialog4.id = item.id
      this.dialog4.typeName = item.typeName
    },
    // 弹框编辑流程分类
    submitDialog4() {
      if (this.dialog4.flowName === '') {
        this.$message.warning('流程分类名称不能为空！')
        return
      }
      var date = {
        id: this.dialog4.id,
        typeName: this.dialog4.typeName
      }
      saveFlowType(date).then((data) => {
        if (data.code === 10000) {
          this.processList[this.gropList_index].typeName = this.dialog4.typeName
          // this.$message.success('流程分组编辑成功！')
          this.dialog4.addDounced = false
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 设置流程状态
    setUpFlowStatusDialog(item, index) {
      this.$confirm('此操作将改变流程状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var date = {
          id: item.id
        }
        setUpFlowStatus(date).then((data) => {
          if (data.code === 10000) {
            // if (this.processList && this.processList.length > 0) {
            //   this.processList.map((item) => {
            //     if (item.id === '1') {
            //       console.log(this.processList[this.gropList_index].List[index].status, '88888')
            //       setTimeout(() => {
            //         this.processList[this.gropList_index].List[index].status = data.result.status
            //       }, 500)
            //     } else {
            //       this.processList[this.gropList_index].List[index].status = data.result.status
            //     }
            //   })
            // }
            this.$nextTick(() => {
              this.processList[this.gropList_index].List[index].status = data.result.status
            })
            // this.$message.success('流程状态设置成功！')
          }
        }).catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 删除流程分组
    delFlowTypeDialog(item, index) {
      this.$confirm('此操作将永久删除该分组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var date = {
          id: item.id
        }
        delFlowType(date).then((data) => {
          if (data.code === 10000) {
            this.processList.splice(index, 1)
            // this.$message.success('流程分组删除成功！')
          }
        }).catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 删除流程
    delFlowDialog(item, index, grop_id) {
      this.$confirm('此操作将永久删除该流程, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var date = {
          id: item.id
        }
        delFlow(date).then((data) => {
          if (data.code === 10000) {
            if (grop_id === null || grop_id === '') {
              this.list.splice(index, 1)
            } else {
              this.processList[grop_id].formCount -= 1
              this.processList[this.gropList_index].List.splice(index, 1)
            }
            this.$forceUpdate()
            // this.$message.success('流程删除成功！')
          }
        }).catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 返回
    goOut() {
      this.$router.push({
        path: '/Task'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index.scss';
.content {
  position: relative;
  width: 100%;
  height: calc(100% - 20px);
}
.head {
  width: 100px;
  font-size: 14px;
  font-size: $font_16;
  font-family: $font_family1;
  color: $color_3;
  line-height: 22px;
  font-weight: 500;
  padding: 4px 0 16px 0;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  cursor: pointer;
  .go_icon {
    color: $color_9;
    margin: 0 5px 0 0;
  }
}
.content_list {
  width: calc(100% - 0px);
  height: calc(100% - 40px);
  position: absolute;
  background: $color_white;
  border-radius: 4px;
  padding: 32px 30px;
  .data_list {
    width: calc(100% - 100px);
    height: calc(100% - 95px);
    position: absolute;
    overflow: auto;
  }
}
.nav_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.el-input__icon {
  font-size: 22px;
  color: #9e9e9e !important;
  line-height: 36px;
}
.search_input {
  margin-right: 23px;
  height: 36px !important;
  .el-input {
    height: 36px;
    width: 223px;
    border-radius: 4px;
  }
}
.nav_left {
  display: flex;
  align-items: center;
}
.custom_icon {
  font-size: $font_16;
  color: $color_6;
  line-height: 20px;
}
.search_input ::v-deep .el-input__inner {
  height: 36px;
  line-height: 36px;
  padding-left: 35px;
  border-color: #e9e9ea;
}
.nav_box ::v-deep .el-button {
  height: 36px;
  padding: 7px 10px;
  color: $color_6;
}
.nav_box ::v-deep .el-button--primary {
  color: $color_white;
  background: $color_main;
  border-color: $color_main;
}
.content_box {
  // height: 500px;
  position: relative;
  margin-left: 21px;
}
.content_row {
  height: 40px;
  font-size: $font_14;
  font-family: $font_family1;
  font-weight: 400;
  color: $color_3;
  padding: 8px 24px;
  line-height: 24px;
  border-radius: 4px;
}
.content_row:hover {
  background: #f9f9f9;
}
.info_personnel {
  min-width: 65px;
  font-size: $font_12;
  font-family: $font_family1;
  font-weight: 400;
  color: $color_4;
  padding: 4px 10px;
  line-height: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.info_personnel1 {
  // width: 65px;
  font-size: $font_12;
  font-family: $font_family1;
  font-weight: 400;
  color: $color_4;
  line-height: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.info_personnel_surname {
  width: 24px;
  height: 24px;
  font-size: $font_14;
  font-family: $font_family1;
  font-weight: 400;
  color: $color_white;
  line-height: 24px;
  text-align: center;
  color: $color_white;
  background: $color_main;
  border-radius: 50%;
  margin-right: 8px;
}
.content_btn {
  display: flex;
  justify-content: end;
  align-items: center;
}
.icon_btn {
  color: $color_6;
  margin-left: 30px;
  font-size: $font_16;
  cursor: pointer;
}
.cover_boxs {
  margin: 0 14px;
}
.info_subject {
  display: flex;
  align-items: baseline;
  font-size: $font_14;
  font-family: $font_family1;
  font-weight: 400;
  color: $color_6;
  line-height: 22px;
  border-bottom: 1px solid #E9E9EA;
  margin-bottom: 25px;
}
.info_subject::before {
  content: '*';
  color: #FF4D42;
}
.info_subject ::v-deep .el-textarea__inner {
  padding: 5px 10px;
  border: none;
}
.create_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.create_key {
  width: 100px;
  display: flex;
  align-items: center;
}
.create_value {
  width: calc(100% - 100px);
}
.create_icon {
  color: $color_9;
  // font-size: 12px;
  margin-right: 5px;
}
.create_value ::v-deep .el-select {
  width: 100%;
}
.create_value ::v-deep .el-select .el-input__inner {
  width: 433px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  border-color: #E9E9EA;
  color: $color_6;
}
.create_value ::v-deep .el-input__icon {
  height: 35px;
  line-height: 35px;
  color: $color_c;
}
.permissions_box {
  margin: 0 40px;
  height: 247px;
}
.permissions_label {
  font-size: $font_16;
  font-family: $font_family1;
  font-weight: 500;
  color: $color_3;
  line-height: 22px;
  margin: 10px 0;
}
.permissions_value {
  font-size: $font_14;
  font-family: $font_family1;
  font-weight: 400;
  color: $color_6;
  margin: 5px 0 20px 20px;
}

.users_personnel {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 10px;
}
.user_personnel {
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.user_personnel:hover {
  background: #f6f6f6;
}
.user_personnel:hover .del_icon {
  display: block;
}
.permissions_personnel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 3px 0;
  border-radius: 4px;
}
.permissions_personnel:hover {
  background: #f6f6f6;
}
.del_icon {
  font-size: $font_16;
  color: $color_9;
  position: absolute;
  top: -6px;
  right: -6px;
  display: none;
  cursor: pointer;
}
.del_icon:hover {
  color: $color_main;
}
.info_icon_show:hover {
  color: $color_main;
}
.add_icon {
  font-size: $font_20;
  color: $color_9;
  margin: 0 10px;
  cursor: pointer;
}
.add_icon:hover {
  color: $color_main;
}
.choose_icon {
  font-size: $font_14;
  color: $color_main;
  margin-right: 10px;
}

.content_list ::v-deep .el-collapse-item__wrap{
  will-change: unset!important;
}
</style>
